import { getFiltersByLocalStorageKey } from '../../Utilities/FilterUtilities'

export const initialState = {
  activeCategory: null,
  error: false,
  errorDetails: {
    code: null,
    message: null
  },
  filters: getFiltersByLocalStorageKey('MY_WORK_QUEUE_FILTERS'),
  items: null,
  lastRequestId: null,
  loading: false,
  resultsMode: 'table',
  selected: {},
  selectedDetails: null,
  selectedIndex: null,
  templates: {}
}

const MyWorkQueueReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_WORK_QUEUE_STATE':
      return initialState
    case 'SET_WORK_QUEUE_ITEMS':
      return {
        ...state,
        items: { ...state.items, [action.category]: action.items },
        templates: { ...state.templates, [action.category]: action.template }
      }
    case 'SET_WORK_QUEUE_ERROR':
      return {
        ...state,
        error: action.error
      }
    case 'SET_WORK_QUEUE_ERROR_DETAILS':
      return {
        ...state,
        errorDetails: action.errorDetails
      }
    case 'SELECT_WORK_QUEUE_ITEM':
      return {
        ...state,
        selected: {
          [action.category]:
            state.selected[action.category] !== action.selected ? action.selected : null
        }
      }
    case '@@wq/SET_ACTIVE_CATEGORY':
      return { ...state, activeCategory: action.category }
    case '@@wq/SET_FILTERS':
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.category]: action.filters
        }
      }
    case '@@wq/SET_REQUEST_ID':
      return { ...state, lastRequestId: action.requestId }
    case '@@wq/SET_LOADING':
      return {
        ...state,
        loading: action.loading
      }
    case '@@wq/INVALIDATE_CACHE':
      return {
        ...state,
        selected: {},
        selectedDetails: null,
        selectedIndex: null
      }
    default:
      return state
  }
}

export default MyWorkQueueReducer



// WEBPACK FOOTER //
// ./src/components/MyWorkQueue/MyWorkQueueReducer.js